const pdfFileMap = new Map<string, File>();

export default pdfFileMap;